// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"c4c08731","752":"c5088968"}[chunkId] + ".chunk.js";
};